import { useState, useEffect, useRef } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  makeStyles, Button, Box, Grid, Snackbar,
} from '@material-ui/core';



import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// import DevicesList from './DevicesList';
import { useTranslation } from './LocalizationProvider';
import { api_call, empty, get_utc_timestamp_ms, setShareUri } from './helpers/untils';
import { RECAPTCHA_ENABLED } from './config/constant';
import { getSettingPersist, setSettingPersist } from './helpers/misc';
import CaptchaBox from './components/CaptchaBox';
import { useLocation } from "react-router-dom"
import TemporaryFacilityMap from './TemporaryFacilityMap';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: 0,
    top: 0,
    margin: theme.spacing(1.5),
    width: theme.dimensions.drawerWidthDesktop,
    bottom: 56,
    zIndex: 1301,
    transition: 'transform .5s ease',
    backgroundColor: 'white',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      margin: 0,
    },
  },
  sidebarCollapsed: {
    transform: `translateX(-${theme.dimensions.drawerWidthDesktop})`,
    marginLeft: 0,
    [theme.breakpoints.down('md')]: {
      transform: 'translateX(-100vw)',
    },
  },
  paper: {
    zIndex: 1,
  },
  toolbar: {
    display: 'flex',
    padding: theme.spacing(0, 1),
    '& > *': {
      margin: theme.spacing(0, 1),
    },
  },
  deviceList: {
    flex: 1,
  },
  sidebarToggle: {
    position: 'absolute',
    left: theme.spacing(1.5),
    top: theme.spacing(3),
    borderRadius: '0px',
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      left: 0,
    },
  },
  sidebarToggleText: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  sidebarToggleBg: {
    backgroundColor: 'white',
    color: '#777777',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
}));

const TemporaryFacilityPage = () => {
  //const current = moment();
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const location = useLocation();
  const dispatch = useDispatch();
  const t = useTranslation();

  const { shareUrl } = useParams();

  const params = new URLSearchParams(location.search)
  const mode = params.get("mode")
  const isTest = mode === 'test' ? true : false

  const [verified, setVerified] = useState(false)
  const refVerifyField = useRef(false)

  const [authenticated, setAuthenticated] = useState(true);
  const [currentLink, setCurrentLink] = useState(null)
  const refCurLink = useRef({})
  const [deviceList, setDeviceList] = useState([])
  const [deviceMarkerList, setDeviceMarkerList] = useState([])

  const createDeviceMarkerList = (device_list) => {
    const markerList = []
    for (let k in device_list) {
      const device = device_list[k];
      const row = {
        id: device.id,
        name: device.name,
        category: device.category,
        latitude: device.latitude,
        longitude: device.longitude,
        //...device
      }
      markerList.push(row)
    }
    return markerList;
  }

  const loadLinkInfo = async (is_loop = false) => {
    if (shareUrl) {
      const response = await api_call(`/api/shuttle-info/${shareUrl}`);
      if (response.ok) {
        const link = await response.json();
        const shuttleInfo = link.shuttleInfo || {}
        setCurrentLink(shuttleInfo)
        refCurLink.current = shuttleInfo

        const device_list = shuttleInfo.deviceList || []
        setDeviceList(device_list)
        const markerList = createDeviceMarkerList(device_list)
        setDeviceMarkerList(markerList)

        if (is_loop) {
          setTimeout(() => {
            loadLinkInfo(is_loop)
          }, 60 * 1000) /////////////// every 1 minute
        }
      } else {
        // if (response.error) {
        //   setToastMessage(response.error)
        //   setSnackbarOpen(true)
        // }
        redirectMainPage()
      }
    } else {
      redirectMainPage()
    }
  }

  const redirectMainPage = () => {
    history.push("/");
  }

  useEffect(() => {
    setShareUri(shareUrl)
    loadLinkInfo(true)
  }, [shareUrl]);

  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isPhone = useMediaQuery(theme.breakpoints.down('xs'));

  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => setCollapsed(isTablet), [isTablet]);

  ///////////// start recaptcha part //////////////////////////////////////////////////////////////////////////
  const captchaKey = 'captcha_temp_facility'
  const [recaptcha, setRecaptcha] = useState(RECAPTCHA_ENABLED === "false" ? "xxxxxxxxxxxxxxxxx" : "");
  const [captchaTimestamp, setCaptchaTimestamp] = useState(get_utc_timestamp_ms());
  const updateCaptchaSettingEnabled = (value) => {
    const oldValue = getSettingPersist(captchaKey)
    if (oldValue !== value) {
      setSettingPersist(captchaKey, value)
      setCaptchaTimestamp(get_utc_timestamp_ms())
    }
  }
  ///////////// end recaptcha part //////////////////////////////////////////////////////////////////////////

  const [formData, setFormData] = useState({})
  const onChangeFormInput = (event, field_name) => {
    let form_data = { ...formData }
    form_data[field_name] = event.target.value
    setFormData(form_data)
  }
  const [apiLoading, setApiLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (RECAPTCHA_ENABLED === "true" && empty(recaptcha)) {
      alert("You are not a robot?")
      return false
    }

    setVerified(true)
    refVerifyField.current = true
    return true
  }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  ///////////////////////////////////////////////////////////////////////////////////////////////////
  const linkVerifyForm = () => {
    return (
      <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ width: '100%', maxWidth: '320px', margin: 'auto' }}>
          <form onSubmit={handleSubmit}>
            <Grid container direction="column" spacing={1}>
              {
                (RECAPTCHA_ENABLED === "true") && (<>
                  <Grid item>
                    <CaptchaBox
                      recaptcha={recaptcha}
                      setRecaptcha={setRecaptcha}
                      captchaKey={captchaKey}
                      captchaTimestamp={captchaTimestamp}
                      defaultEnabled={true}
                    />
                  </Grid>
                </>)
              }

              <Grid item>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"

                  disabled={apiLoading}
                  fullWidth
                >
                  Go
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={1500}
        message={toastMessage}
      />

      {
        (authenticated) ? (
          <>
            {
              (!verified) ? (
                <>
                  {
                    linkVerifyForm()
                  }
                </>
              ) : (
                <>
                  <TemporaryFacilityMap
                    shuttleInfo={currentLink}
                    deviceList={deviceList}
                    deviceMarkerList={deviceMarkerList}
                  />
                </>
              )
            }
          </>
        ) : (
          <div></div>
        )
      }
    </div>
  )
}

export default TemporaryFacilityPage
